import { render, staticRenderFns } from "./CustomerListPage.vue?vue&type=template&id=5b427594&"
import script from "./CustomerListPage.vue?vue&type=script&lang=js&"
export * from "./CustomerListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports